import {
    getApiDatabasesAdminAll,
    postApiDatabasesAdminCoaDefinitions,
    postApiDatabasesManualDatabaseSync,
    getApiDatabasesByDatabaseIdCoaDefinitions,
    postApiDatabasesMeta,
    getApiDatabasesAdminCompanies,
    deleteApiDatabasesCompaniesByCompanyIdDatabasesByDatabaseId,
    postApiDatabasesCompaniesByCompanyIdDatabases,
} from "@/generated";

import { handleApiResponseAssertData } from "./handleApiResponseAssertData";
import { handleApiResponse } from "./handleApiResponse";

export const apiDatabases = {
    syncDatabases: async () =>
        handleApiResponse(postApiDatabasesManualDatabaseSync),
    getAvailableCoAsForDatabaseId: (databaseId: number) =>
        handleApiResponseAssertData(
            () =>
                getApiDatabasesByDatabaseIdCoaDefinitions({
                    path: { database_id: databaseId },
                }),
            "Failed to get available COAs for database",
        ),
    getAdminDatabases: () =>
        handleApiResponseAssertData(
            () => getApiDatabasesAdminAll(),
            "Failed to get all databases",
        ),
    getAdminCoAsForDatabaseIds: (databaseIds: number[]) =>
        handleApiResponseAssertData(
            () =>
                postApiDatabasesAdminCoaDefinitions({
                    body: databaseIds,
                }),
            "Failed to get admin COAs for database",
        ),
    getDatabaseMetadata: (databaseIds: number[]) =>
        handleApiResponseAssertData(
            () => postApiDatabasesMeta({ body: databaseIds }),
            "Failed to get database metadata",
        ),
    getCompanies: () =>
        handleApiResponseAssertData(
            () => getApiDatabasesAdminCompanies(),
            "Failed to get companies",
        ),
    createCompanyDatabase: ({
        databaseName,
        companyId,
    }: {
        databaseName: string;
        companyId: number;
    }) =>
        handleApiResponseAssertData(
            () =>
                postApiDatabasesCompaniesByCompanyIdDatabases({
                    path: { company_id: companyId },
                    query: { database_name: databaseName },
                }),
            "Failed to create database",
        ),
    deleteCompanyDatabase: ({
        databaseId,
        companyId,
        force,
    }: {
        databaseId: number;
        companyId: number;
        force?: boolean;
    }) =>
        handleApiResponse(
            () =>
                deleteApiDatabasesCompaniesByCompanyIdDatabasesByDatabaseId({
                    path: { database_id: databaseId, company_id: companyId },
                    query: { force },
                }),
            "Failed to delete database",
        ),
};
